import type { Customer } from 'src/interfaces/customer'
import { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getCustomers = (state: State): Customer[] => state.customer.customers

export const getCustomersLoading = (state: State): boolean => state.customer.customersLoading

export const getCustomersError = (state: State): string | null => state.customer.customersError

export const getCustomer = (state: State): Customer | null => state.customer.customer

export const getCustomerLoading = (state: State): boolean => state.customer.customerLoading

export const getCustomerError = (state: State): string | null => state.customer.customerError

export const getCustomerCreating = (state: State): boolean => state.customer.creating
